// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("flu:cart:item-added", function (evt) {
  console.log("Item added to the cart", evt.detail.product);
}); // This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("flu:cart:updated", function (evt) {
  console.log("Cart updated", evt.detail.cart);
}); // This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.

document.addEventListener("flu:cart:error", function (evt) {
  console.log(evt.detail.errorMessage, "Cart error");
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener("flu:quick-cart:open", function (evt) {
  console.log("Quick cart opened", evt.detail.cart);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.

document.addEventListener("flu:quick-cart:close", function () {
  console.log("Quick cart closed");
}); // This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.

document.addEventListener("flu:product:variant-change", function (evt) {
  console.log("Product variant changed", evt.detail.variant);

  if(evt.detail.variant.inventory_quantity < 4 && evt.detail.variant.inventory_quantity > 0 && evt.detail.variant.inventory_policy == 'deny' && evt.detail.variant.inventory_management == 'shopify'){
    $("#variant-inventory").html(evt.detail.variant.inventory_quantity +" left in stock"); 
  }
  else{
    $("#variant-inventory").html(''); 
  }
  
}); // This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.

document.addEventListener("flu:product:quantity-update", function (evt) {
  console.log("Product quantity updated", evt.detail.quantity, evt.detail.variant);
}); // This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick shop' feature is enabled
// And a quick view modal is opened.

document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

document.addEventListener("DOMContentLoaded", function () {

  // Loop through each swatch button
  const swatchButtons = document.querySelectorAll('.product-form__chips button[data-button]');
  if(swatchButtons){
  
    swatchButtons.forEach(button => {
    const variantId = button.getAttribute('data-button');
    const selectOption = document.querySelector(`select.product-form__chip-select option[data-value-handle="${variantId}"]`);
    
    if (selectOption && selectOption.getAttribute('data-soldout') === 'true') {
      button.classList.add('sold-out');
    }
  });
  }
  
 // Check if nav.mega element exists
 const header = document.querySelector('header[data-section-type="header"]');
 const headerLinkList = document.querySelector('.header__links-list');
 const megaLinks = document.querySelectorAll('li[data-submenu-parent] a[data-mega="true"]');
 const megaLis = document.querySelectorAll('li[data-submenu-parent]');
 const megaNavs = document.querySelectorAll('nav.mega-nav');
 const megaNavContainers = document.querySelectorAll('.mega-nav__container');
 const megaNavOverlay = document.querySelectorAll('.mega-nav__overlay');
 let megaMenuTimeout; // Declare a variable to hold the timeout ID

  
  function addClassesOnMouseEnter(event) {
   megaLis.forEach((megaLi) => {
     const childMegaLink = megaLi.querySelector('nav.mega-nav');
     if(childMegaLink){
      childMegaLink.classList.remove('active');
      childMegaLink.classList.remove('visible');
     }
    });
                     
    const parentLi = event.target.closest('li[data-submenu-parent]');
    if (parentLi) {
      const childMegaNav = parentLi.querySelector('nav.mega-nav');
      if(childMegaNav){
        childMegaNav.classList.add('active');
        childMegaNav.classList.add('visible');
      }
    }
    header.classList.remove('header--transparent-home');
  }

  function removeClasses(event) {
                    
    megaLis.forEach((megaLi) => {
     const childMegaLink = megaLi.querySelector('nav.mega-nav');
     if(childMegaLink){
      childMegaLink.classList.remove('active');
      childMegaLink.classList.remove('visible');
     }
    });
    
  }

 function hideMegaMenuWithDelay() {
  megaMenuTimeout = setTimeout(() => {
    removeClasses();
  }, 500); // Adjust the delay as needed (e.g., 500 milliseconds)
}

function clearMegaMenuTimeout() {
  clearTimeout(megaMenuTimeout);
}

// Add event listeners for hover
megaLinks.forEach((megaLink) => {
  megaLink.addEventListener('mouseenter', (event) => {
    addClassesOnMouseEnter(event);
    clearMegaMenuTimeout(); // Clear the timeout when entering the mega menu
  });

  megaLink.addEventListener('mouseleave', (event) => {
    hideMegaMenuWithDelay(); // Hide the mega menu with a delay
  });
});

// Add event listeners for hover
megaNavs.forEach((megaNav) => {
   // Add an event listener to clear the timeout when re-entering the mega menu
  megaNav.addEventListener('mouseenter', () => {
    clearMegaMenuTimeout();
  });
});

// Add event listeners for hover
megaNavOverlay.forEach((navOverlay) => {
   navOverlay.addEventListener('mouseover', () => {
     removeClasses();
  });
});

  
});

